module.exports = __webpack_public_path__ + "static/media/ourstories-screen_three-guys_gay-pride-parade.61a4e4d5.png";